import { useEffect, useState } from "react"
import type { SelectOptionType, SuccessFetch } from "../../../../../../../../types"
import { useApi } from "../../../../../../../../utils"

export function usePaymentTerm() {
  const api = useApi()
  const [data, setData] = useState<SelectOptionType[]>([])
  const [isLoading, setLoading] = useState(false)

  const refetch = () => {
    setLoading(true)

    api.get("/paymentterm/")
    .then((res: SuccessFetch<{
      payload: {
        payment_term_id: number
        payment_term_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.payment_term_name, value: item.payment_term_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
  }

  useEffect(() => {
    setLoading(true)

    api.get("/paymentterm/")
    .then((res: SuccessFetch<{
      payload: {
        payment_term_id: number
        payment_term_name: string
      }[]
    }>) => { setData(res.data.payload.map(item => { return { label: item.payment_term_name, value: item.payment_term_id.toString() }}))})
    .catch(() => setData([]))
    .finally(() => setLoading(false))
    // eslint-disable-next-line
  }, [])

  return { data, isLoading, refetch }
}